/* global axios */
import ApiClient from './ApiClient';

class WhatsappCampaignsAPI extends ApiClient {
  constructor() {
    super('whatsapp_campaigns', { accountScoped: true });
  }

  toggle(campaignId) {
    return axios.post(`${this.url}/${campaignId}/toggle`);
  }

  test(campaignId) {
    return axios.post(`${this.url}/${campaignId}/test`);
  }

  restart(campaignId) {
    return axios.post(`${this.url}/${campaignId}/restart`);
  }

  runNow(campaignId) {
    return axios.post(`${this.url}/${campaignId}/run_now`);
  }
}

export default new WhatsappCampaignsAPI();
